import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MediaChange } from '@angular/flex-layout';
import { NavigationEnd, Router } from '@angular/router';
import { MediaReplayService } from '@brokerportal/common/services/media-replay.service';
import { AuthenticationService } from '@brokerportal/common/auth/authentication.service';
import { Subscription } from 'rxjs';
import { SubNavigationService } from '../services/sub-navigation.service';
import { FeatureFlagService, PortalConfigurationService, SalesIqService } from '@brokerportal/common/services';
import { BrokerPortalFeatureCodes } from '@brokerportal/common/enums';

@Component({
    selector: 'bp-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('sidenav', { static: true }) sidenav;
    @ViewChild('scrollContainer', { static: true }) scrollContainer;

    private _mediaSubscription: Subscription;
    private _routerEventsSubscription: Subscription;

    sidenavOpen = true;
    sidenavMode = 'side';
    isMobile = false;

    constructor(
        private router: Router,
        private mediaReplayService: MediaReplayService,
        private authenticationService: AuthenticationService,
        private subNavigationService: SubNavigationService,
        private elementRef: ElementRef,
        private portalConfigurationService: PortalConfigurationService,
        private featureFlagService: FeatureFlagService,
        private salesIqService: SalesIqService
    ) {}

    ngOnInit() {
        this._mediaSubscription = this.mediaReplayService.isMobile$.subscribe(isMobile => {
            this.isMobile = isMobile;
            this.sidenavMode = isMobile ? 'over' : 'side';
            this.sidenavOpen = !isMobile;
        });

        this._routerEventsSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && this.isMobile) {
                this.sidenav.close();
            }
        });

        this.authenticationService.isAuthenticated().subscribe(result => {
            if (result && this.router.url === '/') {
                this.router.navigateByUrl('/dashboard');
            }
        });

        this.subNavigationService.navigation$.subscribe(navigation =>
            this.onActivate(navigation, this.scrollContainer.nativeElement)
        );
    }

    ngAfterViewInit() {
        this.authenticationService.isAuthenticated().subscribe(result => {
            if (result) {
                this.portalConfigurationService.get().subscribe(portalConfig => {
                    this.salesIqService.load(portalConfig.user, this.elementRef.nativeElement);
                });
            }
        });
    }

    ngOnDestroy() {
        if (this._mediaSubscription) {
            this._mediaSubscription.unsubscribe();
        }

        if (this._routerEventsSubscription) {
            this._routerEventsSubscription.unsubscribe();
        }

        this.salesIqService.hide();
    }

    onActivate(e, scrollContainer) {
        scrollContainer.scrollTop = 0;
    }
}
